import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_GPS_STOPPED = "SET_GPS_STOPPED";
export const SET_POSITION = "SET_POSITION";
export const GEOLOCALISATION_IN_PROGRESS = "GEOLOCALISATION_IN_PROGRESS";
